// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"91d6d837","977":"e988e1f5"}[chunkId] + ".chunk.js";
};